module.exports = __webpack_public_path__ + "static/img/3.b642944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/3.png
// module id = LBbF
// module chunks = 35